import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'reviews';

export const REVIEWS_ENDPOINTS = {
  createReview: () => formatEndpoint('', namespace),
};
